module.exports = __webpack_public_path__ + "img/0e8f6f5.png";